import { FC, PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentCompany, useCurrentUser, useIdentity } from '@bonusly/who-am-i';

import { PageLoading } from '../components/loading';
import { PUBLIC_PATH_PREFIX } from './public-path';

export const AppLoading: FC<PropsWithChildren> = ({ children }) => {
	const { isUserIdentified } = useIdentity();
	const company = useCurrentCompany();
	const user = useCurrentUser();
	const { i18n, t } = useTranslation('monarch');

	useEffect(() => {
		const locale = user?.locale || company?.locale;

		if (locale) {
			i18n.changeLanguage(locale);
		}
	}, [company?.locale, i18n, user]);

	// The public form is reachable by anonymous visitors who will never become
	// identified. Render the router immediately for `/public/*` so the identity
	// gate below never blanks the page on the login loader. Hooks above still run
	// (Rules of Hooks); they no-op against the empty identity store.
	if (window.location.pathname.startsWith(PUBLIC_PATH_PREFIX)) {
		return <>{children}</>;
	}

	if (!isUserIdentified) {
		return <PageLoading>{t('loading')}</PageLoading>;
	}

	return <>{children}</>;
};
